import { Login } from './login/login';

export function PublicLayout() {
  return (
    <div>
      <div className='flex h-screen w-screen flex-col items-center justify-center'>
        <Login authPath='/auth' />
      </div>
    </div>
  );
}
